import * as React from 'react'

export const IconWarningMsg: React.FC<React.SVGProps<SVGSVGElement>> = (
  props: Omit<
    React.SVGProps<SVGSVGElement>,
    'dominantBaseline' | 'textAnchor' | 'clipRule' | 'fillRule' | 'strokeLinecap' | 'strokeLinejoin'
  >
) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" {...props}>
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M13.66 6.323c-.77-1.33-2.69-1.33-3.461 0l-5.461 9.432c-.772 1.334.19 3.002 1.73 3.002h10.923c1.54 0 2.502-1.668 1.73-3.002z"
      />
      <path
        fill="#fff"
        d="M11.932 14.698a.65.65 0 1 0 0 1.3.65.65 0 0 0 0-1.3m0-.865c.39 0 .65-.312.65-.78v-2.338c0-.467-.26-.779-.65-.779s-.65.312-.65.78v2.337c0 .468.26.78.65.78"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1="11.93"
        x2="11.93"
        y1="3.333"
        y2="18.758"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3DD4D" />
        <stop offset="1" stopColor="#E0BC49" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M4 3.333h16v16H4z" />
      </clipPath>
    </defs>
  </svg>
)
